// Copyright (c) StrangeBee 2024

import { QueryClient } from 'react-query';
import { Client } from 'thehive-sdk';

let apiUrl = (window as any)?.API_URL as string | undefined;

if (apiUrl?.endsWith('/')) {
    apiUrl = apiUrl.substring(0, apiUrl.length - 1);
}

const client = new Client({ apiUrl });

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        },
    },
});

export default client;
